import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import FormDatePicker from "../../components/formFields/FormDateField";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import moment from "moment";
import { RootState } from "../../app/store";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import { findAllActiveItem } from "../item/services/item.services";
import {
  createDullReceipt,
  findAllPendingDullOrder,
  getDullReceiptById,
  updateDullReceipt,
} from "./services/dullReceipt.services";
import { findAllActiveProcess } from "../process/services/process.services";
import { clearDullReceiptDetail } from "./dullReceiptSlice";
import { ErrorToast } from "../../components/toast/Toasts";
import { clearOrderDetail } from "../order/orderSlice";
import DullReceiptOrderItemArray from "./DullReceiptOrderItemArray";
import FormTextField from "../../components/formFields/FormTextField";
import DullReceiptOrderSelectionDialog from "./DullReceiptOrderSelectionDialog";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { clearKarigarStock } from "../karigar/karigarSlice";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const KarigarChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const KarigarList = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const charges = formRenderProps.valueGetter("charges");
  const gold_rate = formRenderProps.valueGetter("gold_rate");
  const dull_receipt_order = formRenderProps.valueGetter("dull_receipt_order");
  const dispatch = useAppDispatch();

  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      dispatch(findAllPendingDullOrder({ karigar_id: karigar_id }));
      fetchKarigarStock(karigar_id);
      if (karigar_id && KarigarList?.length > 0) {
        const selectedKarigar = KarigarList.find(
          (karigar) => karigar.karigar_id === karigar_id,
        );
        if (selectedKarigar) {
          const Rate = selectedKarigar?.rate;
          formRenderProps.onChange(`charges`, {
            value: Rate || 0,
          });
        }
      }
    }
  }, [karigar_id]);

  useEffect(() => {
    if (dull_receipt_order && dull_receipt_order.length > 0) {
      dull_receipt_order?.forEach((element: any, index: number) => {
        const total_charge = (element.issue_weight || 0) * (charges || 0);
        const ghat_weight =
          (element.issue_weight || 0) - (element.received_weight || 0);
        const amount = (ghat_weight || 0) * (gold_rate || 0);
        formRenderProps.onChange(`dull_receipt_order.${index}.total_charge`, {
          value: total_charge,
        });
        formRenderProps.onChange(`dull_receipt_order.${index}.ghat_weight`, {
          value: ghat_weight,
        });
        formRenderProps.onChange(`dull_receipt_order.${index}.amount`, {
          value: amount,
        });
      });
    }
  }, [
    dull_receipt_order?.map((item: any) => item?.issue_weight).join("-"),
    dull_receipt_order?.map((item: any) => item?.received_weight).join("-"),
    charges,
    gold_rate,
  ]);
  return null;
};
const CreateDullReceipt: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dull_receipt_guid = location?.state?.dull_receipt_guid;
  const loading = useAppSelector((state) => state.dullreceipt?.loading);
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const DullReceiptDetail = useAppSelector(
    (state: RootState) => state.dullreceipt.DullReceiptDetail,
  );
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.dull));
    dispatch(findAllActiveItem());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearDullReceiptDetail());
      dispatch(clearOrderDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    if (dull_receipt_guid) {
      dispatch(getDullReceiptById(dull_receipt_guid));
    }
  }, [dull_receipt_guid]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [DullReceiptDetail]);

  const handleSubmit = async (values: any) => {
    if (values.dull_receipt_order?.length === 0) {
      ErrorToast("At least One Order is Required !");
      return false;
    }
    const formData = {
      karigar_id: values.karigar_id ? +values.karigar_id : null,
      receipt_date: values.receipt_date
        ? moment(values.receipt_date).format("YYYY-MM-DD")
        : "",
      charges: values?.charges ? values?.charges : 0,
      gold_rate: values?.gold_rate ? values?.gold_rate : 0,

      dull_receipt_order: values.dull_receipt_order
        ? values.dull_receipt_order.map((dullreceiptOrder: any) => {
            return {
              id: dullreceiptOrder.id ? dullreceiptOrder.id : 0,
              order_id: dullreceiptOrder.order_id
                ? +dullreceiptOrder.order_id
                : null,
              item_id: dullreceiptOrder.item_id
                ? +dullreceiptOrder.item_id
                : null,
              item_description: dullreceiptOrder.item_description
                ? dullreceiptOrder.item_description
                : "",
              issue_weight: dullreceiptOrder.issue_weight
                ? dullreceiptOrder.issue_weight
                : 0,
              received_weight: dullreceiptOrder.received_weight
                ? dullreceiptOrder.received_weight
                : 0,
              total_charge: dullreceiptOrder.total_charge
                ? dullreceiptOrder.total_charge
                : 0,
              ghat_weight: dullreceiptOrder.ghat_weight
                ? dullreceiptOrder.ghat_weight
                : 0,
              amount: dullreceiptOrder.amount ? dullreceiptOrder.amount : 0,
              isfinishorder: dullreceiptOrder.isfinishorder
                ? dullreceiptOrder.isfinishorder
                : false,
              IsVerified: dullreceiptOrder.IsVerified
                ? dullreceiptOrder.IsVerified
                : false,
            };
          })
        : [],
    };
    if (dull_receipt_guid) {
      const editPayload = {
        dull_receipt_guid: dull_receipt_guid,
        dull_receipt_no: values.dull_receipt_no,
        ...formData,
      };
      try {
        const response = await dispatch(updateDullReceipt(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/dullreceipt");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createDullReceipt(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/dullreceipt");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };
  const handleFormClose = () => {
    navigate("/dullreceipt");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={DullReceiptDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <DullReceiptOrderSelectionDialog
              formRenderProps={formRenderProps}
            />
            <KarigarChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {dull_receipt_guid
                      ? "Update Dull Receipt"
                      : "Create Dull Receipt"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {dull_receipt_guid ? (
                    <Typography.h5>
                      Dull Receipt No :{" "}
                      <span style={{ color: "green" }}>
                        {DullReceiptDetail.dull_receipt_no}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.dull}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="receipt_date"
                    label="Receipt Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  rowSpan={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  {" "}
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="charges"
                    label="Charges"
                    placeholder="i.e. 2"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="gold_rate"
                    label="Gold Rate (GM)"
                    placeholder="i.e. 8500"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 10 }}>
              <GridLayout cols={[{ width: "100%" }]}>
                <GridLayoutItem>
                  <Typography.h4>Dull Receipt Orders</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={DullReceiptOrderItemArray}
                    name="dull_receipt_order"
                    dull_receipt_guid={dull_receipt_guid}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  {isPrintAccess && dull_receipt_guid && (
                    <Button
                      type="button"
                      style={{ marginRight: 4 }}
                      fillMode={"solid"}
                      themeColor={"primary"}
                      onClick={() =>
                        window.open(
                          `/dullreceipt/${dull_receipt_guid}`,
                          "_blank",
                        )
                      }
                    >
                      <FaEye style={{ fontSize: "18" }} /> View Report
                    </Button>
                  )}
                  <ButtonWithLoading
                    label={!dull_receipt_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateDullReceipt;
